import { datadogRum } from "@datadog/browser-rum";
import { AppConfiguration } from "../types/app-configuration";


export function initializeDataDog(config: AppConfiguration) {
  datadogRum.init({
    applicationId: '<application id>',
    clientToken: '<client token>',
    site: 'us3.datadoghq.com',
    service: '<app name>',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: config.apiRootUrl, propagatorTypes: ["datadog"]}
    ]
  });
}
